import dynamic from "next/dynamic";

// const LogosSlider = dynamic(() => import('../common/LogosSlider'))
import ServiceFullBanner from '../service-details/service-details-layout/service-full-banner/service-banner'
import LogosSlider from "../common/LogosSlider";
import Hire from './opt-to-hire/opt-to-hire'

const BookConsultant = dynamic(() => import('../services/service-book-consultant/bookconsultant'))
const OurSpectrums = dynamic(() => import('./our-spectrums/our-spectrums'))
const IndustryStrategies = dynamic(() => import('./strategies/strategies'))
const Faq = dynamic(() => import('../home-new/faq/faq'))

function Industry(props) {

    let blocks = props.blocks;

    return (
        <>
            {blocks.length > 0 &&
                <div className="middle-sction industry-middle industries-middel">
                    {
                        blocks.map((block, i) => {
                            return (
                                <div key={i}>
                                    {
                                        block.__component === "blocks.service-banner" &&
                                        <>
                                            <ServiceFullBanner block={block} />
                                            <LogosSlider />
                                        </>
                                    }
                                    {
                                        block.__component === "blocks.opt-to-hire" &&
                                        <Hire block={block} />
                                    }
                                    {
                                        block.__component === "blocks.our-spectrums" &&
                                        <OurSpectrums block={block} />
                                    }
                                    {
                                        block.__component === "blocks.strategies" &&
                                        <IndustryStrategies block={block} />
                                    }
                                    {
                                        block.__component === "blocks.faq" &&
                                        <Faq data={block} />
                                    }
                                    {
                                        block.__component === "blocks.book-consultations" &&
                                        <BookConsultant block={block} />
                                    }
                                </div>
                            )
                        })
                    }
                </div>
            }
        </>
    );
}

export default Industry;
